import * as angular from 'angular';
import { each } from 'lodash';

export class RunHistoryController {
  static $inject = ['$scope', 'ReportRunModel'];

  public runsCollection: any;
  public currentRunToken: string;
  private runs: any[];
  private loading: boolean;

  constructor(
    private $scope,
    private ReportRunModel
  ) {
    this.loading = true;
  }

  $onChanges(changed) {
    if (changed.runsCollection) {
      this.watchRunsCollection();
    }
  }

  watchRunsCollection() {
    this.runsCollection.watch(this.$scope, (runs) => {
      this.ReportRunModel.buildRunsWithCreator(runs)
        .then((runsWithAccountAndParams) => {
          this.runs = runsWithAccountAndParams;
          this.runs.map((run) => {
            run.hasShareLink = !!(run._resource.links('share') && run._resource.links('share').href);
          });
          this.loading = false;
        })
        .catch(function (e) {
          this.loading = false;
        });
    });
  }

  generateTooltip(run) {
    if (!angular.equals({}, run.parameters)) {
      let str = '';
      each(run.form_fields, function (formField) {
        const escapedParameName = formField.name.toString().replace(/\'/g, "\\'");
        const paramValue = formField.value || '';
        const escapedParamValue = paramValue.toString().replace(/\'/g, "\\'");
        str += '<div>' + escapedParameName + '<br>' + escapedParamValue + '</div>';
      });
      return str;
    }
    return '';
  }

  more() {
    if (!this.runsCollection) {
      return;
    }
    this.loading = true;
    this.runsCollection.next().then((runsCollection) => {
      this.runsCollection = runsCollection;
    });
  }
}

RunHistoryController.$inject = ['$scope', 'ReportRunModel'];

export const runHistoryComponent: angular.IComponentOptions = {
  bindings: {
    runsCollection: '<',
    currentRunToken: '@',
  },
  template: `
<div class="well next-well">
  <ul class="dynamic-rows">
    <li class="dynamic-row" ng-repeat="run in ctrl.runs | orderBy: '-createdAt'">
      <span
        class="html-tooltip">
        <span
          class="dynamic-row-link"
          ng-class="{active: ctrl.currentRunToken === run.token, 'has-link': run.hasShareLink}"
          uib-tooltip-html="'{{ ::ctrl.generateTooltip(run) }}'">
          <a
            ng-href="{{ run._resource.links('share').href }}"
            target="_self">
            <span class="open-link" ng-if="run.hasShareLink">Open Run</span>
            <run-history-row class="row" run="run"></run-history-row>
          </a>
        </span>
      </span>
    </li>
  </ul>
  <span class="runs-loader" ng-show="ctrl.loading">
    Loading&hellip;
  </span>
  <p class="empty-msg" ng-show="!ctrl.loading && (!ctrl.runs || !ctrl.runs.length)">This {{ type }} has not been run yet.</p>
  <a href="#" ng-click="ctrl.more()" ng-show="!ctrl.loading" class="runs-more" ng-if="ctrl.runsCollection && ctrl.runsCollection.hasNext()">Show More Runs</a>
</div>

`,
  controller: RunHistoryController,
  controllerAs: 'ctrl',
};
